import { render } from "./LatestThreePeriod.vue?vue&type=template&id=120a55f4&scoped=true"
import script from "./LatestThreePeriod.vue?vue&type=script&lang=js"
export * from "./LatestThreePeriod.vue?vue&type=script&lang=js"

import "./LatestThreePeriod.vue?vue&type=style&index=0&id=120a55f4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120a55f4"]])

export default __exports__